// extracted by mini-css-extract-plugin
export default {"branding":"Branding_branding__C5HQN"};